import { ResearchStatus } from '@eiq/projects/data';
import { UiPalette } from '@eiq/ui';

import { ProjectStatus } from './project-status.enum';

export const ProjectStatusLabels: Record<ProjectStatus, string> = {
  [ProjectStatus.Prelaunch]: 'Prelaunch',
  [ProjectStatus.Launched]: 'Launched',
  [ProjectStatus.Closed]: 'Closed',
  [ProjectStatus.Archived]: 'Archived'
};

export const ProjectStatusBadge: Record<ProjectStatus, UiPalette> = {
  [ProjectStatus.Prelaunch]: 'alert',
  [ProjectStatus.Launched]: 'success',
  [ProjectStatus.Closed]: 'warn',
  [ProjectStatus.Archived]: 'warn'
};

export const ResearchStatusLabels: Record<ResearchStatus, string> = {
  [ResearchStatus.Draft]: 'Prelaunch',
  [ResearchStatus.Live]: 'Launched',
  [ResearchStatus.Offline]: 'Offline',
  [ResearchStatus.Closed]: 'Closed',
  [ResearchStatus.LiveEditing]: 'Launched'
};

export const ResearchStatusBadge: Record<ResearchStatus, UiPalette> = {
  [ResearchStatus.Draft]: 'alert',
  [ResearchStatus.Live]: 'success',
  [ResearchStatus.Offline]: 'alert',
  [ResearchStatus.Closed]: 'warn',
  [ResearchStatus.LiveEditing]: 'success'
};
